import moment from 'moment';

// Zahlungsziel einer Rechnung: 30 Tage ab invoice_date (Format DD.MM.YYYY,
// strikt geparst). Der Server-Guard fuer Zahlungserinnerungen
// (node-backend locations.js, sendPaymentReminder) prueft dieselbe Grenze.
export const PAYMENT_TERM_DAYS = 30;

// Liefert true, wenn das Zahlungsziel abgelaufen ist, false, wenn nicht,
// und null, wenn invoice_date fehlt oder nicht parsebar ist. Die Aufrufer
// entscheiden selbst, was "unbekannt" bedeutet (Rechnungsfilter: sichtbar
// lassen; Zahlungserinnerung: der Server entscheidet).
export function isPastPaymentTerm(invoice) {
  const invoiceDate = moment(invoice && invoice.invoice_date, 'DD.MM.YYYY', true);
  if (!invoiceDate.isValid()) return null;
  return moment().diff(invoiceDate, 'days') >= PAYMENT_TERM_DAYS;
}

// Zustand einer Rechnung aus den Feldern von location_billings (#1116):
//   'storno'    Storno-Beleg (cancel_invoice, traegt paid:true)
//   'cancelled' storniertes Original (cancelled:true, paid bleibt false)
//   'paid'      bezahlt
//   'open'      offen
// Storno zuerst, weil der Beleg auch paid:true traegt; cancelled vor paid,
// damit ein storniertes Original nie als offen zaehlt. Bestandsdaten ohne
// Backfill haben kein cancelled und fallen wie bisher auf paid/open.
export function invoiceState(invoice) {
  if (!invoice) return 'open';
  if (invoice.cancel_invoice) return 'storno';
  if (invoice.cancelled === true) return 'cancelled';
  if (invoice.paid) return 'paid';
  return 'open';
}

// Anzeige "Storniert durch RE-<nr>", ohne Nummer nur "Storniert".
export function cancelledLabel(invoice) {
  const nr = invoice && invoice.cancelled_by_invoice_nr;
  return nr ? 'Storniert durch RE-' + nr : 'Storniert';
}
